import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-accordion',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-accordion works!</p> `,
  styles: ``,
})
export class CpAccordionComponent {}
